export function convert1DArrayTo2D<Type>(array: Type[], len: number): Type[][] {
  const newArr = []
  const arrCopy = [...array]
  while (arrCopy.length) newArr.push(arrCopy.splice(0, len))
  return newArr
}
